<template>
  <div id="chart">
    <apexchart height="245" type="donut" :options="chartOptions" :series="chartOptions.series"></apexchart>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: ['indicadores'],
  data: function () {
    return {
      series1: [2, 4, 5, 6],
      labels1: ["a", "b", "c", "d"],
    };
  },
  computed: {
    chartOptions: function () {
      return {
        colors: ["#1976D2", "#2196F3", "#03A9F4", "#00BCD4"],
        legend: {
          fontSize: "14px",
          fontFamily: "Helvetica, Arial",
          fontWeight: 400,
          itemMargin: {
            vertical: 10,
          },
          formatter: function (seriesName, opts) {
            return (
              '<div class="legend-info">' +
              "<span>" +
              seriesName +
              ": " +
              "</span>" +
              "<span>" +
              opts.w.globals.series[opts.seriesIndex] +
              "</span>" +
              "</div>"
            );
          },
        },
        dataLabels: {
          enabled: false,
        },
        labels: ["Empresa", "ONG", "Asociación", "Cluster"],

        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: "22px",
                  fontFamily: "Roboto",
                  color: "#dfsda",
                  offsetY: -10,
                },
                value: {
                  show: true,
                  fontSize: "16px",
                  fontFamily: "Roboto",
                  color: undefined,
                  offsetY: 16,
                  formatter: function (val) {
                    return val;
                  },
                },
                total: {
                  show: true,
                  label: "Total",
                  color: "#373d3f",
                  formatter: function (w) {
                    return w.globals.seriesTotals.reduce((a, b) => {
                      return a + b;
                    }, 0);
                  },
                },
              },
            },
          },
        },
        series: [this.indicadores.empresa_total, this.indicadores.ong_total, this.indicadores.asociacion_total, this.indicadores.cluster_total],
      };
    },
  },
};
</script>